<template lang="pug">
.banner.w-full.h-auto
  swiper-container.banner(ref="bannerSwiper", class="landscape:xl:h-full", :modules="[Autoplay]", loop="true", autoplay-delay="2500", autoplay-disable-on-interaction="false", autoplay-pause-on-interaction="false", autoplay-stop-on-interaction="false", :navigation="false", :pagination="false", lazy="true")
    swiper-slide.gtm-activity-item.flex.justify-center.h-auto(v-for="banner in list", :key="banner.activityNo", :class="[redirect ? 'cursor-pointer' : '', 'portrait:aspect-[5/2]']", data-location="ad", :data-activity-no="banner.activityNo", :data-template="banner.template", :data-activity-name="banner.name", :data-activity-type-name="banner.activityTypeName")
      img.w-auto.h-full.object-contain(:src="bannerImg(banner)", :alt="getTitle(banner)", loading="lazy")
</template>

<script setup>
import { Autoplay } from 'swiper/modules'
import { ref, onMounted, onBeforeUnmount } from 'vue'

import { useNuxtApp } from '#app'
import { useMainStore } from '@/stores/main'
import filterLocaleSetting from '@/utils/localeSetting'

const props = defineProps({
  redirect: {
    type: Boolean,
    default: true,
  },
  list: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: 'carouselUrl',
  },
  pagination: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['showCustomerService'])

const { $analytics } = useNuxtApp()
const store = useMainStore()
const { setModalParams, setTrackLocation, setModal } = store
const { locale } = useI18n()
const { locale: defaultLocale } = useSite()
const { getCdnUrl } = useCdnAssets()
const bannerSwiper = ref(null)

onMounted(() => {
  bannerSwiper.value.swiper.on('click', handleClick)
})

onBeforeUnmount(() => {
  bannerSwiper.value?.swiper.off('click', handleClick)
})

const bannerImg = (banner) => {
  if (banner?.activityTypeName?.toUpperCase() === 'PROMOTIONS') {
    return getCdnUrl(filterLocaleSetting(banner.localeSetting, locale, defaultLocale, props.type))
  } else {
    return getCdnUrl(banner?.[props.type]?.[0]?.url) || ''
  }
}

const getTitle = (banner) => {
  return filterLocaleSetting(banner?.localeSetting, locale, defaultLocale, 'title')
}

// 取得輪播圖點擊後目標
const getCarouselUrl = (item) => {
  if (item.externalLink) {
    window.open(item.externalLink, '_blank')
  } else if (item.serviceButtonEnable === 1) {
    emit('showCustomerService')
  }
}

const handleClick = (s, e) => {
  const activityTarget = props.list.find(({ activityNo }) => activityNo === e.target.dataset.activityNo)
  if (activityTarget && activityTarget.displayMode === 'carouselImage') {
    getCarouselUrl(activityTarget)
  } else if (props.redirect) {
    const activityNo = e.target.dataset.activityNo
    const template = e.target.dataset.template
    const activityName = e.target.dataset.activityName
    const activityTypeName = e.target.dataset.activityTypeName

    $analytics.push({
      event: 'activity_click',
      location: 'ad',
      activityNo: activityNo,
      template: template,
      activityName: activityName,
    })
    setModalParams({ typeName: activityTypeName, id: activityNo })
    setTrackLocation(`Banner|${activityName}`)
    setModal('ModalMission')
  }
}
</script>

<style lang="scss">
.banner {
  .swiper-container {
    z-index: 0;
  }
}
</style>
